// extracted by mini-css-extract-plugin
export default {"title":"GroupManagement_title__DJWap"};